<template lang="pug">
  .romania
    .title-img-wrap
      .img-bg
      img(
      src="@/assets/images/countries/romania-min.png"
      )
      span {{ gettext('Румыния') }}
    p.type-thin {{ gettext('Общие данные о стране') }}
    .content.one-grid
      div
        p {{ gettext('Румыния уже 10 лет является членом Евросоюза, который открыл для её граждан границы не только для безпреградного перемещения по территории Европейского союза, но и для трудоустройства. Румыния на сегодня показывает хорошие темпы роста и развития экономики, но несмотря на это, страна не может обеспечить достаточное количество рабочих мест с достойной оплатой труда для своих граждан. По этой причине показатель трудовой миграции румын до сих пор держится на высоком уровне.') }}
        p {{ gettext('Румыны - гордая и в то же время гостеприимная нация, которая уважает демократичность и стремится к лучшему будущему для себя и своих детей, трудясь для этого во многих развитых странах мира. Румыны серьезно относятся к трудовым обязанностям и дорожат своим трудовым статусом.') }}
        p {{ gettext('Румыны достаточно легки на подъем, веселы и приветливы, они глубоко ценят свою семью и социальные отношения. ') }}
        p {{ gettext('Большинство румын работают в Германии, Испании, Италии, Венгрии, Великой Британии, США, Франции, Бразилии, Украине, Австрии, Бельгии, странах Скандинавии. По подсчетам румынской власти, состоянием на 2018 год, около 3,5 миллионов граждан страны являются трудовыми эмигрантами в странах Европы.') }}
        p {{ gettext('В каких сферах трудятся румыны? От самых востребованных сфер по критерию недостатка рабочей силы: строительство, сельское хозяйство, сфера обслуживания, транспорт, производство, здравоохранение и персональная помощь, до трудоустройства согласно своей квалификации, в тех же сферах, а также и других: социальных услуг, образования, связи, промышленных технологий, торговли.') }}
        p {{ gettext('Румынская рабочая сила поддерживает и развивает экономику многих стран, поэтому румын с радостью берут на работу. Также, в процессе трудоустройства они имеют привилегию перед гражданами третьих стран: им не нужно проходить длительный процесс оформления разрешений на работу, виз и видов на жительство, что делает их более доступными и «легкими» работниками в глазах работодателей. Последние характеризуют румын как добросовестных и старательных работников.') }}

        router-link(:to="`/${getLanguage}/countries`")
          button.main-btn.bg-transparent.google
            | {{ gettext('See other countries') }}
</template>
<script>

import { gettext } from '@/services/TranslateHandler'
import { mapGetters } from 'vuex'
import mixin from '@/mixins'

export default {
  props: ['country'],
  mixins: [
    mixin
  ],
  metaInfo () {
    return this.getMetaInfoMixin({defaultMetaInfo: this.defaultMetaInfo, sharedImg: document.location.origin + 'webapp/images/countries/romania-min.png'})
  },
  name: 'Romania',
  methods: {
    gettext: gettext
  },
  computed: {
    ...mapGetters([
      'getLanguage'
    ]),
    defaultMetaInfo () {
      return {
        title: 'Romania | ' + gettext('Countries'),
        titleTemplate: null,
        link: [
          {rel: 'canonical', href: document.location.origin + document.location.pathname}
        ]
      }
    }
  }
}
</script>

<style lang='scss' src='../country/styles.scss'></style>



// WEBPACK FOOTER //
// src/pages/countries/romania/index.vue